export const rootPath = document.getElementsByTagName('base')[0]?.getAttribute('href');

export function emailValidation(value) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value);
  }
  
  export function phoneValidation(value) {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(value);
  }

